import { takeLatest } from 'redux-saga/effects';
import {
    GET_EMPLOYMENTS_REQUEST,
    ADD_EMPLOYMENT_REQUEST,
    REMOVE_EMPLOYMENT_REQUEST,
    CONFIRM_EMPLOYMENT_REQUEST,
    UPDATE_EMPLOYMENTS_REQUEST,
    UPDATE_EMPLOYMENTUNITS_REQUEST
} from "../constants/employmentActionTypes";
import {
    getEmploymentsSuccess,
    getEmploymentsFailure,
    addEmploymentSuccess,
    addEmploymentFailure,
    removeEmploymentSuccess,
    removeEmploymentFailure,
    confirmEmploymentSuccess,
    confirmEmploymentFailure,
    updateEmploymentsSuccess,
    updateEmploymentsFailure,
    updateEmploymentUnitsSuccess,
    updateEmploymentUnitsFailure
} from "../actions/employmentActions";
import { handleApiRequest } from '../utils/sagaUtils';
import {apiCall} from "../utils/api";

const getEmployments = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employment-api/getEmployments`, 'POST', data);
const addEmployment = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employment-api/addEmployment`, 'POST', data);
const removeEmployment = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employment-api/removeEmployment`, 'POST', data);
const confirmEmployment = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employment-api/confirmEmployment`, 'POST', data);
const updateEmployments = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employment-api/updateEmployments`, 'POST', data);
const updateEmploymentUnits = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employment-api/updateEmploymentUnits`, 'POST', data);

function* getEmploymentsSaga(action) {
    yield* handleApiRequest(action, getEmployments, getEmploymentsSuccess, getEmploymentsFailure);
}

function* addEmploymentSaga(action) {
    yield* handleApiRequest(action, addEmployment, addEmploymentSuccess, addEmploymentFailure);
}

function* removeEmploymentSaga(action) {
    yield* handleApiRequest(action, removeEmployment, removeEmploymentSuccess, removeEmploymentFailure);
}

function* confirmEmploymentSaga(action) {
    yield* handleApiRequest(action, confirmEmployment, confirmEmploymentSuccess, confirmEmploymentFailure);
}

function* updateEmploymentsSaga(action) {
    yield* handleApiRequest(action, updateEmployments, updateEmploymentsSuccess, updateEmploymentsFailure);
}

function* updateEmploymentUnitsSaga(action) {
    yield* handleApiRequest(action, updateEmploymentUnits, updateEmploymentUnitsSuccess, updateEmploymentUnitsFailure);
}

export default function* watchEmploymentSagas() {
    yield takeLatest(GET_EMPLOYMENTS_REQUEST, getEmploymentsSaga);
    yield takeLatest(ADD_EMPLOYMENT_REQUEST, addEmploymentSaga);
    yield takeLatest(REMOVE_EMPLOYMENT_REQUEST, removeEmploymentSaga);
    yield takeLatest(CONFIRM_EMPLOYMENT_REQUEST, confirmEmploymentSaga);
    yield takeLatest(UPDATE_EMPLOYMENTS_REQUEST, updateEmploymentsSaga);
    yield takeLatest(UPDATE_EMPLOYMENTUNITS_REQUEST, updateEmploymentUnitsSaga);
}